import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const defaultOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
  transition: Slide,
};

const ToastService = {
  success: (message, options) => {
    toast.success(message, { ...defaultOptions, ...options });
  },
  error: (message, options) => {
    toast.error(message, { ...defaultOptions, ...options });
  },
  info: (message, options) => {
    toast.info(message, { ...defaultOptions, ...options });
  },
  warning: (message, options) => {
    toast.warning(message, { ...defaultOptions, ...options });
  },
  info: (message, options) => {
    toast.info(message, { ...defaultOptions, ...options });
  },
};

export { ToastService };
